import * as React from "react";
import type { JSX } from "react";

import { FormCheckbox } from "@impero-com/common/components/legacyWidgets";
import { t } from "@impero-com/common/utils/i18n";
import { Arrow } from "@impero-com/ui";
import { Dropdown, MenuProps, Space } from "antd";

import * as theme from "./theme.css";

export function ColumnDropdown(props: ColumnDropdownProps): JSX.Element {
    const [open, setOpen] = React.useState(false);

    const items: MenuProps["items"] = [
        {
            type: "group",
            label: (
                <div className={theme.tableMenuSectionTitle}>
                    {t("ControlResult_Columns")}
                </div>
            ),
            children: props.columns
                .filter(({ value: { label } }) =>
                    Boolean(label && label.trim() !== "")
                )
                .map(
                    ({
                        value: { name, label },
                        available,
                        displayed,
                        onToggle,
                    }) => ({
                        key: name,
                        label: (
                            <div key={name}>
                                <FormCheckbox
                                    id={`columndropdown-${name}-checkbox`}
                                    label={label}
                                    checked={displayed}
                                    disabled={!available}
                                    onChange={onToggle}
                                />
                            </div>
                        ),
                        disabled: !available,
                    })
                ),
        },
    ];

    return (
        <Dropdown
            menu={{ items }}
            trigger={["click"]}
            placement="bottomRight"
            overlayClassName={theme.tableMenuContainer}
            open={open}
            onOpenChange={setOpen}
        >
            <Space className={theme.tableMenuTrigger}>
                {t("ControlResult_AdjustView")}
                <Arrow />
            </Space>
        </Dropdown>
    );
}

export interface ColumnDropdownProps {
    columns: Array<ColumnSpec>;
}

export interface ColumnSpec {
    value: { name: string; label: string };
    available: boolean;
    displayed: boolean;
    onToggle: (checked: boolean) => void;
}
